import React from 'react';
import { X } from 'lucide-react';

function Modal({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  size = 'md',
  showCloseButton = true,
  className = ''
}) {
  if (!isOpen) return null;

  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl'
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50 overflow-hidden"
      onClick={handleBackdropClick}
    >
      <div className={`bg-white rounded-2xl shadow-xl w-full ${sizeClasses[size]} mx-auto max-h-[95vh] sm:max-h-[90vh] overflow-hidden ${className} relative`}>
        {/* Header */}
        {(title || showCloseButton) && (
          <div className="flex items-center justify-between p-4 sm:p-6 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50 flex-shrink-0">
            {title && (
              <h2 className="text-lg sm:text-xl font-bold text-gray-900 truncate pr-2">{title}</h2>
            )}
            {showCloseButton && (
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded-lg transition-colors ml-auto flex-shrink-0"
              >
                <X className="h-5 w-5 text-gray-500" />
              </button>
            )}
          </div>
        )}

        {/* Content */}
        <div className="overflow-y-auto flex-1" style={{ maxHeight: 'calc(95vh - 120px)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Modal;